exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".sign-in-link .fa-icon[data-v-795102b2]{vertical-align:text-bottom}.body-text[data-v-795102b2]{font-size:15px;color:#999;line-height:150%}", "", {"version":3,"sources":["C:/Work/widget/src/components/Customer/C:\\Work\\widget/src\\assets\\scss\\Customer\\ForgotPasswordForm.scss"],"names":[],"mappings":"AAAA,wCAEI,0BAA2B,CAC5B,AAGH,4BACE,eAAc,AACd,WAAU,AACV,gBAAiB,CAClB","file":"ForgotPasswordForm.vue","sourcesContent":[".sign-in-link{\r\n  .fa-icon{\r\n    vertical-align: text-bottom;\r\n  }\r\n}\r\n\r\n.body-text{\r\n  font-size:15px;\r\n  color:#999;\r\n  line-height: 150%;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-795102b2","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Customer/ForgotPasswordForm.vue
// module id = 1046
// module chunks = 0